import React, { useState } from "react";
import aImg from '../../images/aslam/Asslam22.webp'

// import aImg from "../../images/aslam/Asslam11.webp";
import { Link } from "react-scroll";
import "./style.css";

const About = (props) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <section
      className={`tf-about-section section-padding${expanded ? " about-section-expanded" : ""}`}
    >
      <div className="container">
        <div className="tf-about-wrap">
          <div
            className={`row ${expanded ? "align-items-start" : "align-items-center"}`}
          >
            <div
              className={`col-lg-6 col-md-12 col-12${expanded ? " about-img-sticky" : ""}`}
            >
              <div className="tf-about-img">
                <img src={aImg} alt="" />
                {/* <div className="tf-about-img-text">
                  <div className="tf-about-icon">
                    <h3>18+</h3>
                    <span>Years Experience</span>
                  </div>
                </div> */}
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-12">
              <div className="tf-about-text">
                <small>Meet Asslam Shaikh</small>
                <h2>Visionary Entrepreneur</h2>
                <p className="qualities">
                  TEDx Speaker | Global Education Leader | Mentor
                </p>
                <h5>
                  Founder & CEO of Aliff — making global education accessible to
                  every deserving student.
                </h5>
                <p>
                  Mr. Asslam I. Shaikh is the Founder & CEO of Aliff, an
                  edtech-driven global education company committed to bringing
                  study abroad within the common man's reach. Over the last 18+
                  years, he has helped thousands of students pursue
                  international education by breaking barriers related to
                  affordability, awareness, and accessibility.{" "}
                  {!expanded && (
                    <button
                      className="about-read-more-btn"
                      onClick={() => setExpanded(true)}
                    >
                      Read More...
                    </button>
                  )}
                </p>

                <div
                  className={`about-expand-content ${expanded ? "about-expand-content--open" : ""}`}
                >
                  <p>
                    Under his leadership, Aliff Overseas has established
                    partnerships with more than 770 universities across 22+
                    countries and expanded to 89+ counseling centers spanning
                    India, the Middle East, and Africa.
                  </p>
                  <p>
                    Beyond building a successful organization, Mr. Shaikh is
                    deeply committed to creating impact at scale. As Chairman of
                    the Education Committee at the Bombay Industries
                    Association, he actively contributes to discussions shaping
                    the future of education and workforce development.
                  </p>
                  <p className="tedx-text">
                    His TEDx talk, "You Don't Need To Be Rich To Study Abroad,"
                    has inspired countless students and parents to rethink what
                    is possible. He has also been honored with the Genius Award
                    by Education Times and recognized among India's leading
                    consulting professionals for his contribution to global
                    education.
                  </p>
                  <p>
                    Today, his focus extends beyond students. Through mentoring
                    aspiring edupreneurs, partnering with universities
                    worldwide, and speaking at educational platforms, he
                    continues to build bridges between talent and opportunity.{" "}
                    <button
                      className="about-read-more-btn"
                      onClick={() => setExpanded(false)}
                    >
                      Read Less
                    </button>
                  </p>
                </div>

                <Link
                  activeClass="active"
                  to="contact"
                  spy={true}
                  smooth={true}
                  duration={500}
                  offset={-95}
                  className="theme-btn about-cta-btn"
                >
                  Connect with Asslam Shaikh
                </Link>

                <div className="tf-funfact">
                  <div className="tf-funfact-item">
                    <h3>
                      <span>18</span>+
                    </h3>
                    <p>Years of Experience</p>
                  </div>
                  <div className="tf-funfact-item">
                    <h3>
                      <span>770</span>+
                    </h3>
                    <p>University Partners</p>
                  </div>
                  <div className="tf-funfact-item">
                    <h3>
                      <span>89</span>+
                    </h3>
                    <p>Counseling Centers</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="about-rotate-text-clip">
        <div className="visible-rotate-text">
          <h1>About</h1>
        </div>
      </div>
    </section>
  );
};

export default About;
